module.exports = __webpack_public_path__ + "img/settings.09576215.svg";